import type { CouponCampaign, CouponCampaignKind } from '../types';

function absolutizeEnvUrl(raw: string | undefined): string {
  const trimmed = raw?.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;
  if (typeof window === 'undefined') return trimmed;
  return `${window.location.origin}${trimmed.startsWith('/') ? '' : '/'}${trimmed}`;
}

/** Site-wide default template from env (promotional vs building unit). */
export function resolveCouponTemplateEnvUrl(kind: CouponCampaignKind = 'promotional'): string {
  const key =
    kind === 'building_unit'
      ? (import.meta.env.VITE_BUILDING_UNIT_TEMPLATE_IMAGE_URL as string | undefined)
      : (import.meta.env.VITE_COUPON_TEMPLATE_IMAGE_URL as string | undefined);
  return absolutizeEnvUrl(key);
}

/** Embedded PDF cache saved at upload time (avoids Storage CORS). */
export function resolveCampaignTemplateDataUrl(
  campaign: Pick<CouponCampaign, 'printTemplateImageDataUrl'> | null | undefined
): string | null {
  const cached = campaign?.printTemplateImageDataUrl?.trim();
  return cached && cached.startsWith('data:') ? cached : null;
}

/** Campaign upload wins, then env default for that campaign kind. */
export function resolveCampaignTemplateUrl(
  campaign: Pick<CouponCampaign, 'campaignKind' | 'printTemplateImageUrl'> | null | undefined
): string {
  const uploaded = campaign?.printTemplateImageUrl?.trim();
  if (uploaded) {
    if (uploaded.startsWith('http://') || uploaded.startsWith('https://')) return uploaded;
    return absolutizeEnvUrl(uploaded);
  }
  return resolveCouponTemplateEnvUrl(campaign?.campaignKind ?? 'promotional');
}
